<!-- Backdrop (dropdown desktop only) -->
@if(isOpen && desktopMode === 'dropdown') {
  <div class="panel__backdrop" (click)="close.emit()"></div>
}

<div class="panel"
  [class.panel--open]="isOpen"
  [class.panel--inline]="desktopMode === 'inline'"
  [class.panel--dropdown]="desktopMode === 'dropdown'"
  [class.panel--mobile-only]="desktopMode === 'mobile-only'">
  <ng-content></ng-content>
</div>
